module.exports = __webpack_public_path__ + "img/no-pict.60c70b0f.png";